import React, { PureComponent } from 'react';
import IframeComponent from '../components/iframe/Iframe';
import { RESOURCE_URLS } from '../app/config';

export default class Resources extends PureComponent {
  render() {
    let type = this.props.match.params.type;
    type = type && RESOURCE_URLS[type] ? type : 'api';
    return <IframeComponent src={RESOURCE_URLS[type]} target="_parent" />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/Resources.js